const initState = {
  poses: [],
  poseFilter: {
    levels: ['Beginner', 'Intermediate', 'Advanced'],
    types: []
  }
}

const siteReducer = (state = initState, action) => {
  switch(action.type) {
    case 'CREATE_POSE':
      console.log('Pose created successfully');
      return {
        ...state
      }
    case 'UPDATE_FILTERS':
      return {
        ...state,
        poseFilter: {
          ...state.poseFilter,
          levels: action.levels
        }
      }
    case 'UPDATE_TYPES': 
      return {
        ...state,
        poseFilter: {
          ...state.poseFilter,
          types: action.types
        }
      }
    default:
      // console.warn('No action type handler in siteReducer', action);
      return state;
  }
}

export default siteReducer